export default __webpack_public_path__ + "static/media/loading.cb19b701.gif";